import React, { useRef, useEffect, useState } from 'react';
import NavBars from '../../Sidebar/Sidebar';
import './Admin.css';
import Table from './Table';
import { collection, getDocs, deleteDoc, doc, setDoc } from 'firebase/firestore';
import { db } from '../../../firebase';

const Admin_bR = () => {
    const tableRef = useRef(null);
    const [rows, setRows] = useState(0);
    const [data, setData] = useState([]); // State for table data
    const columns = 6; 
    const columnTypes = ['label', 'label', 'label', 'label', 'button', 'button']; 
    const columnNames = ['ID', 'User', 'Date', 'Time', 'Add to Calendar', 'Clear'];
    const buttonNames = ['Clear', 'Add'];

    useEffect(() => {
        const fetchBookings = async () => {
            const bookingsCollection = collection(db, 'bookings');
            const snapshot = await getDocs(bookingsCollection);
            const bookings = snapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data(),
            }));

            const formattedData = bookings.map(booking => [
                booking.id || 'N/A',
                booking.username || 'N/A',
                new Date(booking.startDate).toLocaleDateString() || 'N/A',
                new Date(booking.startTime).toLocaleTimeString() + "  -  " + new Date(booking.endTime).toLocaleTimeString(),
                'Add',
                'Clear'
            ]);

            setData(formattedData); // Set the formatted data
            setRows(formattedData.length); // Set the number of rows based on fetched data
        };

        fetchBookings();
    }, []);

    const handleAddToCalendar = async (rowIndex) => {
        const booking = data[rowIndex];
        const bookingId = booking[0]; // ID is in the first column
    
        // Extract start and end date/times from the booking
        const startDateString = booking[2]; // e.g., "09/01/2024"
        const startTimeString = booking[3].split('  -  ')[0]; // Extract start time
        const endTimeString = booking[3].split('  -  ')[1]; // Extract end time
    
        // Combine date and time for Date constructor
        const startDate = new Date(`${startDateString} ${startTimeString}`);
        const endDate = new Date(`${startDateString} ${endTimeString}`);
    
        // Check if dates are valid
        if (isNaN(startDate) || isNaN(endDate)) {
            console.error('Invalid date or time value:', startDate, endDate);
            return; // Exit if the date is invalid
        }
    
        // Show confirmation dialog for adding the event
        const confirmMessage = `Are you sure you want to add this event to the calendar?\n\nUser: ${booking[1]}\nDate: ${startDateString}\nTime: ${startTimeString} - ${endTimeString}`;
        
        if (!window.confirm(confirmMessage)) {
            return; // Exit if the user cancels
        }
    
        // Prepare the event object for the calendar
        const event = {
            title: 'Lab Open (Lab Event)', // Set the title
            start: startDate, // Use the start Date object
            end: endDate, // Use the end Date object
            projectRef: doc(db, 'Administrator', 'b7vezvAiyvN3qly0F25b')
        };
    
        // Add the event to the calendar-events collection
        await setDoc(doc(db, 'calendar-events', bookingId), event);
    
        // Delete the booking from the bookings collection
        await deleteDoc(doc(db, 'bookings', bookingId));
    
        // Update the local state
        const updatedData = data.filter((_, index) => index !== rowIndex);
        setData(updatedData);
        setRows(updatedData.length);
    
        console.log('Event added and booking cleared:', event);
    };
    
    
    

    const handleClearItem = async (rowIndex) => {
        const booking = data[rowIndex];
        const bookingId = booking[0]; // Assuming ID is in the first column
        const date = booking[2]; // Date
        const time = booking[3]; // Time
    
        // Show confirmation dialog with date and time details
        const confirmMessage = `Are you sure you want to delete this booking?\n\nUser: ${booking[1]}\nDate: ${date}\nTime: ${time}`;
        
        if (window.confirm(confirmMessage)) {
            // Delete the document from Firestore
            await deleteDoc(doc(db, 'bookings', bookingId));
            
            // Fetch updated bookings after deletion
            const updatedData = data.filter((_, index) => index !== rowIndex);
            setData(updatedData);
            setRows(updatedData.length);
        }
    };
    

    return (
        <div>
            <div className="content">
                <Table
                    ref={tableRef}
                    rows={rows}
                    columns={columns}
                    columnTypes={columnTypes}
                    columnNames={columnNames}
                    data={data} // Pass the formatted data to the Table
                    buttonNames={buttonNames}
                    onButtonClick={[
                        handleClearItem,
                        handleAddToCalendar     // Handler for Clear button
                    ]}
                />
            </div>
            <NavBars />
        </div>
    );
};

export default Admin_bR;
